import { Menu, Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { IconButton } from '@/components/ui/Button'
import { Kbd } from '@/components/ui/Kbd'
import { NotificationsPopover } from '@/features/announcements/components/NotificationsPopover'
import { MessagesButton } from '@/features/messaging/components/MessagesButton'
import { tAny } from '@/i18n'
import { UserMenu } from './UserMenu'

interface TopbarProps {
  onOpenNav: () => void
  onOpenSearch?: () => void
  accountHref: string
  portalLabel: string
}

export function Topbar({ onOpenNav, onOpenSearch, accountHref, portalLabel }: TopbarProps) {
  const { t } = useTranslation()
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.userAgent)
  return (
    <header className="sticky top-0 z-30 flex h-header items-center gap-3 border-b border-line bg-surface/80 px-4 backdrop-blur-xl sm:px-6 print:hidden">
      <IconButton label={t('Open navigation')} icon={<Menu />} onClick={onOpenNav} className="lg:hidden" />

      {onOpenSearch ? (
        <button
          type="button"
          onClick={onOpenSearch}
          className="flex h-10 min-w-0 flex-1 items-center gap-2.5 rounded-control border border-line bg-surface-muted px-3 text-sm text-subtle shadow-xs transition-colors hover:border-line-strong hover:bg-surface sm:max-w-md"
          aria-label={t('Search (Ctrl+K)')}
        >
          <Search className="size-4 shrink-0" aria-hidden="true" />
          <span className="truncate">{t('Search pages, students, staff…')}</span>
          <span className="ml-auto hidden items-center gap-0.5 sm:flex">
            <Kbd>{isMac ? '⌘' : 'Ctrl'}</Kbd>
            <Kbd>K</Kbd>
          </span>
        </button>
      ) : (
        <div className="flex-1" />
      )}

      <div className="ml-auto flex items-center gap-1.5 sm:gap-2">
        <span className="hidden rounded-full bg-brand-50 px-2.5 py-1 text-2xs font-semibold tracking-wide text-brand-700 uppercase ring-1 ring-brand-100 md:inline">
          {tAny(portalLabel)}
        </span>
        <MessagesButton />
        <NotificationsPopover />
        <UserMenu accountHref={accountHref} />
      </div>
    </header>
  )
}
